<template>
    <section class="h-[100svh] text-white relative">
        <div class="h-full w-full absolute">
            <TransitionFadeBackground>
                <img class="object-cover h-full w-full" :src="folder.public_cover_path" alt="">
            </TransitionFadeBackground>
            <div class="bg-black opacity-30 w-full h-full absolute z-10 top-0 left-0"></div>
        </div>

        <TransitionFadeTitle>
            <AtomTitleOpaque class="absolute bottom-6 !text-5xl md:!text-7xl lg:!text-8xl lg:!pr-12 break-all pt-6 z-20">
                {{ folder.title }}
            </AtomTitleOpaque>
        </TransitionFadeTitle>
    </section>
</template>

<script>
import AtomTitleOpaque from "../../global/atoms/AtomTitleOpaque.vue";
import TransitionFadeTitle from "../../../transitions/home/TransitionFadeTitle.vue";
import TransitionFadeBackground from "../../../transitions/home/TransitionFadeBackground.vue";
import {mapState} from "vuex";

export default {
    name: 'OrganismFolderHero',
    components: {TransitionFadeBackground, TransitionFadeTitle, AtomTitleOpaque},
    computed: {
        ...mapState({
            folder: state => state.folder.folder
        })
    }
}
</script>
